import { render, staticRenderFns } from "./RouteNavigationBlockingLayer.vue?vue&type=template&id=687ea504&scoped=true&"
import script from "./RouteNavigationBlockingLayer.vue?vue&type=script&lang=js&"
export * from "./RouteNavigationBlockingLayer.vue?vue&type=script&lang=js&"
import style0 from "./RouteNavigationBlockingLayer.vue?vue&type=style&index=0&id=687ea504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687ea504",
  null
  
)

export default component.exports